/**
 * PageFly Variant Presentation Overrides
 * - Preserves option label renames (Color->Finish, Weight->Door Weight, Length->Track Length)
 * - Preserves friendly option text for specific values
 * Run-time DOM transformer so PageFly re-publishes won't erase customizations.
 */
(function () {
  if (window.__PF_VARIANTS_PRESENTATION__) return;
  window.__PF_VARIANTS_PRESENTATION__ = true;

  var LOG_PREFIX = '[PF-Variants-Presentation]';
  
  // Disable logging in production (set to true to enable debug logs)
  var __DEBUG_ENABLED__ = false;
  
  // Throttled logger to prevent console spam
  var __lastLogTime = 0;
  var __lastLogMsg = '';
  var __LOG_THROTTLE_MS = 5000; // Only log same message every 5 seconds
  
  function log() {
    if (!__DEBUG_ENABLED__) return; // Silent in production
    try {
      var args = [].slice.call(arguments);
      var msgKey = JSON.stringify(args);
      var now = Date.now();
      
      // Skip if same message was logged recently
      if (msgKey === __lastLogMsg && (now - __lastLogTime) < __LOG_THROTTLE_MS) {
        return;
      }
      
      __lastLogTime = now;
      __lastLogMsg = msgKey;
      console.debug.apply(console, [LOG_PREFIX].concat(args));
    } catch(_) {}
  }
  
  // Flag to prevent re-entrant calls and MutationObserver feedback loops
  var __isApplying__ = false;
  var __mutationObserver__ = null;

  var LABEL_MAP = {
    'Color': 'Finish',
    'Weight': 'Door Weight',
    'Length': 'Track Length'
  };

  var COLOR_VALUE_MAP = {
    'Clear Anodized': '150 / 628 - Clear Anodized',
    'Similar to Stainless Steel': '113 / 107 - Similar to Stainless Steel',
    'Black Anodized': '109 / 711 - Black Anodized'
  };

  var WEIGHT_VALUE_MAP = {
    'XL150': '150 kg / 330 lb',
    'XL120': '120 kg / 264 lb',
    'L80': '80 kg / 176 lb'
  };

  function trimText(s){ return (s || '').replace(/\s+/g, ' ').trim(); }

  function renameOptionLabels() {
    var labels = document.querySelectorAll('label.pf-variant-label,[data-pf-type="OptionLabel"]');
    labels.forEach(function(label) {
      var txt = trimText(label.textContent);
      if (LABEL_MAP[txt]) {
        if (label.firstChild && label.childNodes.length === 1) {
          label.firstChild.nodeValue = LABEL_MAP[txt];
        } else {
          label.textContent = LABEL_MAP[txt];
        }
      }
    });
  }

  function mapSelectOptions(select) {
    if (!select || select.tagName !== 'SELECT') return;

    var name = select.getAttribute('data-option-name') || '';
    // Unescape any " to get the raw name
    name = name.replace(/"/g, '"').replace(/"/g, '"');

    var mapping = null;
    if (name === 'Color') mapping = COLOR_VALUE_MAP;
    if (name === 'Weight') mapping = WEIGHT_VALUE_MAP;

    if (!mapping) return;

    var changed = false;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var rawText = trimText(opt.text || opt.label || '');
      // If already mapped (contains units or codes), skip unless a direct key exists
      if (mapping[rawText]) {
        var newText = mapping[rawText];
        if (newText && newText !== opt.text) {
          opt.text = newText;
          changed = true;
        }
      }
    }
    if (changed) {
      // Ensure UI updates that depend on change events
      try {
        var ev = new Event('change', { bubbles: true });
        select.dispatchEvent(ev);
      } catch(_) {}
    }
  }

  function applyToAllSelects() {
    var selects = document.querySelectorAll('select.pf-variant-select');
    selects.forEach(mapSelectOptions);
  }

  /**
   * Align the price block so its RIGHT EDGE matches the selects' RIGHT EDGE.
   * Strategy: measure a visible PF select's bounding width and give the price wrapper
   * the same width, then push it to the right with margin-left:auto. Use !important to
   * beat PF inline styles and our own earlier CSS rules.
   */
  function alignPriceRight() {
    try {
      var priceBlocks = document.querySelectorAll('.__pf [data-pf-type="ProductPrice2"]');
      if (!priceBlocks.length) return;
  
      // Prefer a visible PageFly variant select in the swatches area
      var select =
        document.querySelector('.__pf .pf-option-swatches select.pf-variant-select') ||
        document.querySelector('.__pf [data-pf-type="ProductVariantSwatches"] select');
  
      // If no select is present yet (slow render), just right-align without fixing width
      var widthPx = 0;
      if (select) {
        var r = select.getBoundingClientRect();
        widthPx = Math.max(0, Math.round(r.width));
      }
  
      var isMobile = window.innerWidth < 768;

      priceBlocks.forEach(function (el) {
        // Normalize container
        el.style.setProperty('display', 'flex', 'important');
        
        if (isMobile) {
          el.style.setProperty('flex-direction', 'column', 'important');
          el.style.setProperty('align-items', 'flex-end', 'important');
          el.style.setProperty('gap', '4px', 'important');
        } else {
          el.style.setProperty('flex-direction', 'row', 'important'); // Explicit row
          el.style.setProperty('align-items', 'baseline', 'important');
          el.style.setProperty('gap', '10px', 'important');
        }

        el.style.setProperty('flex-wrap', 'nowrap', 'important'); // Prevent stacking
        el.style.setProperty('justify-content', 'flex-end', 'important');
        el.style.setProperty('text-align', 'right', 'important');
        el.style.setProperty('margin-left', 'auto', 'important');
        el.style.setProperty('float', 'none', 'important'); // override earlier float rules
        
        // Remove strict width constraint to allow inline flow
        el.style.setProperty('width', 'auto', 'important');
        el.style.setProperty('max-width', '100%', 'important');
  
        // Inner price item
        try {
          var inner = el.querySelector('[data-pf-type="ProductPrice2Item"]');
          if (inner) {
            inner.style.setProperty('display', 'inline-block', 'important');
            inner.style.setProperty('text-align', 'right', 'important');
            inner.style.setProperty('width', 'auto', 'important');
          }
        } catch (_) {}
      });
    } catch (_) {}
  }

  // Right-justify the Quantity + Add to Cart row on PageFly
  function alignCTARight() {
    try {
      var atc = document.querySelector('.__pf [data-pf-type="ProductATC2"]');
      if (!atc) return;
      var wrap = atc.closest('[data-pf-type="FlexBlock"]') || atc.parentElement;
      if (!wrap) return;

      wrap.style.display = 'flex';
      wrap.style.flexWrap = 'wrap';
      wrap.style.justifyContent = 'flex-end';
      wrap.style.alignItems = 'center';
      wrap.style.gap = '0.5rem';

      var qty = wrap.querySelector('[data-pf-type="ProductQuantity"]');
      if (qty) {
        qty.style.order = '1';
        qty.style.margin = '0 .25rem 0 0';
      }

      atc.style.order = '2';
      atc.style.width = 'auto';
      atc.style.margin = '0';

      // If Better Price link lives here, place on its own right-aligned line
      var better = wrap.querySelector('.better-price-inline');
      if (better) {
        better.style.flexBasis = '100%';
        better.style.textAlign = 'right';
        better.style.marginTop = '.5rem';
        better.style.order = '3';
      }
    } catch(_) {}
  }

  // Make all PageFly variant select wrappers align their RIGHT edge with the price/ATC
  function alignSelectsRight() {
    try {
      // Reference element: price first, otherwise ATC button
      var priceInner = document.querySelector('.__pf [data-pf-type="ProductPrice2"] [data-pf-type="ProductPrice2Item"]');
      var priceWrap  = document.querySelector('.__pf [data-pf-type="ProductPrice2"]');
      var atc        = document.querySelector('.__pf [data-pf-type="ProductATC2"]');
      var refEl = priceInner || priceWrap || atc;
      if (!refEl) return;

      var rect = refEl.getBoundingClientRect();
      var refWidth = Math.max(0, Math.round(rect.width));
      if (!refWidth) return;

      // PF dropdown swatch wrappers (the containers holding the select elements)
      var wrappers = document.querySelectorAll('.__pf .pf-lh.show-label .pf-option-swatches[data-swatch-type="dropdown"]');

      wrappers.forEach(function(w) {
        // Push wrapper to the right and match width with the reference
        w.style.setProperty('justifySelf', 'end', 'important');
        w.style.setProperty('marginLeft', 'auto', 'important');
        w.style.setProperty('width', refWidth + 'px', 'important');
        w.style.setProperty('maxWidth', 'none', 'important');

        // Ensure the actual select fills the wrapper
        var sel = w.querySelector('select.pf-variant-select');
        if (sel) {
          sel.style.setProperty('width', '100%', 'important');
          sel.style.setProperty('maxWidth', '100%', 'important');
          sel.style.setProperty('marginLeft', '0', 'important');
          sel.style.setProperty('marginRight', '0', 'important');
          sel.style.setProperty('textAlign', 'left', 'important');
        }
      });
    } catch(_) {}
  }

   // --- SKU helpers (PageFly scope) ---
    function getPageflyProductIdForSku() {
      try {
        var pfMap = window.__pageflyProducts;
        if (pfMap && typeof pfMap === 'object') {
          var keys = Object.keys(pfMap);
          if (keys.length === 1) return keys[0];
        }
        var el =
          document.querySelector('.__pf [data-pf-type="ProductBox"][data-product-id]') ||
          document.querySelector('[data-pf-type="ProductBox"][data-product-id]');
        if (el) return String(el.getAttribute('data-product-id') || '');
      } catch (_) {}
      return '';
    }
  
    function getPageflyVariantForSku() {
      try {
        var pid = getPageflyProductIdForSku();
        if (!pid) return null;
  
        var idInput =
          document.querySelector('.__pf .pf-product-form input[name="id"][data-product-id="' + pid + '"]') ||
          document.querySelector('.pf-product-form input[name="id"][data-product-id="' + pid + '"]') ||
          document.querySelector('form[action*="/cart/add"] input[name="id"][data-product-id="' + pid + '"]');
  
        var vid = idInput && idInput.value;
        if (!vid) return null;
  
        var map = window.__pageflyProducts || {};
        var pf = map[pid];
        if (!pf || !pf.variants) return null;
  
        var variants = pf.variants;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (String(v.id) === String(vid)) return v;
        }
      } catch (_) {}
      return null;
    }
  
    function ensureSkuNode() {
      try {
        var priceBlock =
          document.querySelector('.__pf [data-pf-type="ProductPrice2"]') ||
          document.querySelector('[data-pf-type="ProductPrice2"]');
        if (!priceBlock || !priceBlock.parentNode) return null;
  
        var skuEl = document.getElementById('pf-variant-sku');
        if (!skuEl) {
          skuEl = document.createElement('div');
          skuEl.id = 'pf-variant-sku';
          skuEl.className = 'pf-variant-sku pf-text-1';
          skuEl.innerHTML =
            '<span class="pf-variant-sku-label">SKU: </span><span class="pf-variant-sku-value"></span>';
          skuEl.style.display = 'block';
          skuEl.style.textAlign = 'right';
          skuEl.style.fontSize = '0.9em';
          skuEl.style.opacity = '0.85';
          skuEl.style.margin = '0 0 4px 0';
  
          priceBlock.parentNode.insertBefore(skuEl, priceBlock);
        }
        return skuEl;
      } catch (_) {}
      return null;
    }
  
    function updateVariantSkuDisplay() {
      // Retain this as a no-op except for cleaning up any previously injected SKU node,
      // so that SKU is no longer shown between the title and price.
      try {
        var skuEl = document.getElementById('pf-variant-sku');
        if (skuEl && skuEl.parentNode) {
          skuEl.parentNode.removeChild(skuEl);
        }
      } catch (_) {}
    }
  
    // --- MPN helpers (PageFly scope) ---
    function ensureMpnNode() {
      try {
        var systemEl = document.getElementById('system-indicator');
        if (!systemEl || !systemEl.parentNode) return null;

        var mpnEl = document.getElementById('pf-variant-mpn');
        if (!mpnEl) {
          mpnEl = document.createElement('div');
          mpnEl.id = 'pf-variant-mpn';
          mpnEl.className = 'system-indicator system-indicator-mpn';
          mpnEl.innerHTML =
            '<span class="system-indicator__label"><strong>MPN: </strong></span><span class="system-indicator__value"></span>';
          
          // Force styles to be normal and inline-ready
          mpnEl.style.setProperty('font-weight', '100', 'important');
          mpnEl.style.setProperty('font-size', '18px', 'important'); // Inherit from price container
          mpnEl.style.setProperty('white-space', 'nowrap', 'important');
          mpnEl.style.setProperty('display', 'block', 'important'); // Flex item
          mpnEl.style.setProperty('text-align', 'right', 'important');
          mpnEl.style.setProperty('margin', '0', 'important');
          mpnEl.style.setProperty('line-height', '1.2', 'important');
        }

        // Ensure placement immediately AFTER the system indicator (so it reads System then MPN)
        if (systemEl.nextElementSibling !== mpnEl) {
          systemEl.parentNode.insertBefore(mpnEl, systemEl.nextSibling);
        }

        return mpnEl;
      } catch (_) {}
      return null;
    }

    function updateVariantMpnDisplay() {
      try {
        var mpnEl = ensureMpnNode();
        if (!mpnEl) return;

        var valueSpan = mpnEl.querySelector('.system-indicator__value');
        if (!valueSpan) return;

        var currentVariant = getPageflyVariantForSku();
        var mpn = currentVariant && currentVariant.sku;

        if (mpn) {
          valueSpan.textContent = mpn;
          mpnEl.style.display = '';
        } else {
          valueSpan.textContent = '';
          mpnEl.style.display = 'none';
        }

        // Custom text for 120kg
        try {
          var txt = getDoorWeightTextPF();
          var T = (txt || '').toUpperCase();
          var is120 = ((/120/.test(T) && (T.indexOf('KG') !== -1 || T.indexOf('LB') !== -1)) || /\bXL120\b/.test(T) || /\bM120\b/.test(T));
          
          var customMsg = mpnEl.querySelector('.pf-custom-120-msg');
          if (is120) {
            if (!customMsg) {
              customMsg = document.createElement('div');
              customMsg.className = 'pf-custom-120-msg';
              customMsg.textContent = 'The Premium XL 120 is a Self-Closing System';
              customMsg.style.fontSize = '0.9em';
              customMsg.style.marginTop = '2px';
              customMsg.style.display = 'block'; 
              mpnEl.appendChild(customMsg);
            }
            customMsg.style.display = 'block';
          } else {
            if (customMsg) customMsg.style.display = 'none';
          }
        } catch(_) {}

        try {
          log('MPN display updated:', mpn);
        } catch (_) {}
      } catch (_) {}
    }
  
    // --- System indicator helpers (PageFly scope) ---
    function mapWeightToSystemPF(txt) {
      const T = (txt || '').toUpperCase();
      if ((/150/.test(T) && (T.includes('KG') || T.includes('LB'))) || /\bXL150\b/.test(T)) return '150XL';
      if ((/120/.test(T) && (T.includes('KG') || T.includes('LB'))) || /\bXL120\b/.test(T) || /\bM120\b/.test(T)) return '120XL';
      if ((/80/.test(T)  && (T.includes('KG') || T.includes('LB'))) || /\bL80\b/.test(T)  || /\bS80\b/.test(T))  return '80L';
      return null;
    }
  
    function getDoorWeightTextPF() {
      // Prefer PageFly variant selects
      var sel = document.querySelector('.__pf select.pf-variant-select[data-option-name="Door Weight"], .__pf select.pf-variant-select[data-option-name="Weight"]')
             || document.querySelector('select.pf-variant-select[data-option-name="Door Weight"], select.pf-variant-select[data-option-name="Weight"]');
      if (sel) {
        var idx = sel.selectedIndex;
        var txt = (sel.options && sel.options[idx] && sel.options[idx].text) || sel.value || '';
        if (txt) return txt.trim();
      }
      // Fallback: any select near a "Door Weight"/"Weight" label
      var selects = document.querySelectorAll('.product-form__input select, .variant-select select, select[name^="options["]');
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        var grp = s.closest('.product-form__input, fieldset') || s.parentElement;
        var lab = grp && grp.querySelector('label, legend');
        var ltxt = ((lab && lab.textContent) || '').toUpperCase();
        if (ltxt.includes('DOOR WEIGHT') || ltxt === 'WEIGHT' || ltxt.includes('WEIGHT')) {
          var idx2 = s.selectedIndex;
          var txt2 = (s.options && s.options[idx2] && s.options[idx2].text) || s.value || '';
          if (txt2) return txt2.trim();
        }
      }
      return '';
    }
  
    // Locate the PageFly "Soft Close" select
    function getSoftCloseSelectPF() {
      try {
        var sel =
          document.querySelector('.__pf select.pf-variant-select[data-option-name="Soft Close"]') ||
          document.querySelector('select.pf-variant-select[data-option-name="Soft Close"]');
        return sel || null;
      } catch (_) {}
      return null;
    }
  
    // Force the Soft Close select to "Yes" if such an option exists.
    function setSoftCloseToYesPF(select) {
      if (!select || select.tagName !== 'SELECT') return false;
      var yesIndex = -1;
      for (var i = 0; i < select.options.length; i++) {
        var opt = select.options[i];
        var txt = (opt.text || opt.label || '').trim();
        var val = (opt.value || '').trim();
        if (/^yes$/i.test(val) || /^yes$/i.test(txt)) {
          yesIndex = i;
          break;
        }
      }
      // Fallback: keep current selection or first option if nothing matched
      if (yesIndex === -1 && select.options.length) {
        yesIndex = select.selectedIndex >= 0 ? select.selectedIndex : 0;
      }
      if (yesIndex >= 0 && select.selectedIndex !== yesIndex) {
        select.selectedIndex = yesIndex;
        try {
          select.value = select.options[yesIndex].value;
        } catch (_) {}
        try {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } catch (_) {}
        return true;
      }
      return false;
    }
  
    // Control Soft Close availability based on Door Weight:
    // - 80 kg / 120 kg: force "Yes" and disable the control
    // - 150 kg: enable the control, default "Yes" unless the user has changed it
    // - Other weights: keep enabled, no forced selection
    function updateSoftCloseControlPF() {
      try {
        var softSel = getSoftCloseSelectPF();
        if (!softSel) {
          try { log('SoftClose update: select not found'); } catch (_) {}
          return;
        }
  
        // Track whether the user has manually changed the value while enabled
        if (!softSel.__softCloseWired) {
          try {
            softSel.addEventListener('change', function () {
              softSel.dataset.softcloseUserChanged = '1';
            });
          } catch (_) {}
          softSel.__softCloseWired = true;
        }
  
        var txt = getDoorWeightTextPF();
        var T = (txt || '').toUpperCase();
        var is150 = ((/150/.test(T) && (T.indexOf('KG') !== -1 || T.indexOf('LB') !== -1)) || /\bXL150\b/.test(T));
        var is120 = ((/120/.test(T) && (T.indexOf('KG') !== -1 || T.indexOf('LB') !== -1)) || /\bXL120\b/.test(T) || /\bM120\b/.test(T));
        var is80  = ((/80/.test(T)  && (T.indexOf('KG') !== -1 || T.indexOf('LB') !== -1)) || /\bL80\b/.test(T)  || /\bS80\b/.test(T));
  
        var behavior = 'unknown';
        var container = softSel.closest('.pf-option-swatches') || softSel.parentElement;
  
        function disableSoftSelect() {
          softSel.disabled = true;
          softSel.setAttribute('aria-disabled', 'true');
          if (container) {
            container.style.opacity = '0.5';
            container.style.pointerEvents = 'none';
          }
        }
  
        function enableSoftSelect() {
          softSel.disabled = false;
          softSel.removeAttribute('aria-disabled');
          if (container) {
            container.style.opacity = '';
            container.style.pointerEvents = '';
          }
        }
  
        if (is120 || is80) {
          // 80 kg and 120 kg: Soft Close must be "Yes" and locked
          setSoftCloseToYesPF(softSel);
          disableSoftSelect();
          behavior = 'force-yes-and-disable';
        } else if (is150) {
          // 150 kg: default to "Yes" but allow the shopper to change it
          enableSoftSelect();
          if (!softSel.dataset.softcloseUserChanged) {
            setSoftCloseToYesPF(softSel);
          }
          behavior = 'enable-default-yes';
        } else {
          // Any other weight: keep enabled, do not force a particular value
          enableSoftSelect();
          behavior = 'enable-unknown-weight';
        }
  
        try {
          log('SoftClose update', {
            weightText: txt,
            is150: is150,
            is120: is120,
            is80: is80,
            behavior: behavior
          });
        } catch (_) {}
      } catch (_) {}
    }
  
    function formatMoney(cents, format) {
      if (typeof cents == 'string') { cents = cents.replace('.', ''); }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || window.__pagefly_setting__ && window.__pagefly_setting__.moneyFormat) || '${{amount}}';

      function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
      }

      switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function updateCompareAtPrice() {
      try {
        var variant = getPageflyVariantForSku();
        var compareEl = document.querySelector('.pf-compare-at-price');
        
        if (!compareEl) {
            // Try to find the price container to inject if missing (though liquid should have handled it)
            var priceContainer = document.querySelector('.__pf [data-pf-type="ProductPrice2"]');
            if (priceContainer) {
                compareEl = document.createElement('span');
                compareEl.className = 'pf-compare-at-price';
                compareEl.style.cssText = 'text-decoration: line-through; margin-right: 10px; color: #666; font-size: 0.9em;';
                priceContainer.insertBefore(compareEl, priceContainer.firstChild);
            } else {
                return;
            }
        }

        if (variant && variant.compare_at_price > variant.price) {
          compareEl.innerHTML = formatMoney(variant.compare_at_price);
          compareEl.style.display = 'inline-block';
        } else {
          compareEl.style.display = 'none';
        }
      } catch (e) {
        log('Error updating compare at price', e);
      }
    }

    function updateSystemIndicator() {
      try {
        var customContainer = document.getElementById('product-system-mpn-container');

        // Dynamic injection for PageFly if container is missing
        if (!customContainer) {
            var pfTitle = document.querySelector('.__pf [data-pf-type="ProductTitle"]') || document.querySelector('[data-pf-type="ProductTitle"]');
            if (pfTitle && pfTitle.parentNode) {
                customContainer = document.createElement('div');
                customContainer.id = 'product-system-mpn-container';
                customContainer.className = 'product__system-mpn-container';
                customContainer.style.marginBottom = '1.5rem';
                customContainer.style.display = 'flex';
                customContainer.style.flexDirection = 'column';
                customContainer.style.alignItems = 'flex-end';
                customContainer.style.textAlign = 'right';
                customContainer.style.gap = '2px';
                pfTitle.parentNode.insertBefore(customContainer, pfTitle.nextSibling);
            }
        }

        // Ensure existing container has these styles
        if (customContainer) {
            customContainer.style.display = 'flex';
            customContainer.style.flexDirection = 'column';
            customContainer.style.alignItems = 'flex-end';
            customContainer.style.textAlign = 'right';
            customContainer.style.gap = '2px';
        }

        // Prefer the actual PF price CONTAINER so we can inject INSIDE it (guaranteed alignment)
        var priceContainer =
          document.querySelector('.__pf [data-pf-type="ProductPrice2"]') ||
          document.querySelector('[data-pf-type="ProductPrice2"]') ||
          document.querySelector('.price-container') ||
          document.querySelector('[id^="price-"].price-container');
  
        // Fallback anchors (older PF structures)
        var anchorFallback =
          document.querySelector('.__pf .pf-16_') ||
          document.querySelector('.pf-product-price') ||
          document.querySelector('.pf-price');
  
        var anchorEl = priceContainer || anchorFallback;
        if (!customContainer && (!anchorEl || !anchorEl.parentNode)) return;
  
        var wrap = document.getElementById('system-indicator');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.id = 'system-indicator';
          wrap.className = 'system-indicator';
          wrap.innerHTML = '<span class="system-indicator__label"><strong>System: </strong></span><span class="system-indicator__value"></span>';
          
          // Force styles
          wrap.style.setProperty('display', 'block', 'important'); // Flex item
          wrap.style.setProperty('text-align', 'right', 'important');
          wrap.style.setProperty('font-weight', '100', 'important');
          wrap.style.setProperty('font-size', '18px', 'important');
          wrap.style.setProperty('margin', '0', 'important');
          wrap.style.setProperty('white-space', 'nowrap', 'important');
          wrap.style.setProperty('line-height', '1.2', 'important');
        }
  
        // Placement strategy:
        // 0) Use custom container if available (below Title)
        // 1) If we have the price container, insert INSIDE it as the first child.
        // 2) Otherwise, insert as a sibling directly BEFORE the best anchor.
        if (customContainer) {
          if (wrap.parentNode !== customContainer) {
            customContainer.appendChild(wrap);
          }
          wrap.style.setProperty('text-align', 'right', 'important');
          wrap.style.setProperty('margin', '0', 'important');
        } else if (priceContainer) {
          wrap.style.setProperty('text-align', 'right', 'important');
          
          var isMobile = window.innerWidth < 768;
          // Force flex layout on the container to align inline - using !important to override any other CSS
          priceContainer.style.setProperty('display', 'flex', 'important');
          
          if (isMobile) {
            priceContainer.style.setProperty('flex-direction', 'column', 'important');
            priceContainer.style.setProperty('align-items', 'flex-end', 'important');
            priceContainer.style.setProperty('gap', '4px', 'important');
          } else {
            priceContainer.style.setProperty('flex-direction', 'row', 'important');
            priceContainer.style.setProperty('align-items', 'baseline', 'important');
            priceContainer.style.setProperty('gap', '15px', 'important'); // Increased gap slightly
          }
          
          priceContainer.style.setProperty('flex-wrap', 'nowrap', 'important');
          priceContainer.style.setProperty('justify-content', 'flex-end', 'important');
          
          // Ensure it can grow
          priceContainer.style.setProperty('width', 'auto', 'important');
          priceContainer.style.setProperty('max-width', '100%', 'important');

          if (wrap.parentNode !== priceContainer) {
            priceContainer.insertBefore(wrap, priceContainer.firstChild);
          }
        } else {
          wrap.style.setProperty('text-align', 'right', 'important');
          if (!(wrap.parentNode === anchorEl.parentNode && anchorEl.previousElementSibling === wrap)) {
            anchorEl.parentNode.insertBefore(wrap, anchorEl);
          }
        }
  
        var valEl = wrap.querySelector('.system-indicator__value');
        var txt = getDoorWeightTextPF();
        var mapped = mapWeightToSystemPF(txt);
        if (mapped) {
          valEl.textContent = mapped;
          wrap.style.display = 'block';
        } else {
          // If we cannot map, hide (requirement: do not show if weight option isn't present)
          wrap.style.display = 'none';
          valEl.textContent = '';
        }
  
        // Keep the MPN block in sync and positioned immediately above the system indicator
        updateVariantMpnDisplay();
  
        // Apply Soft Close rules tied to Door Weight (PageFly option)
        updateSoftCloseControlPF();
      } catch (_) {}
    }
  
    // --- MUTO Comparison Modal helpers ---
    function setupMutoComparisonModal() {
      try {
        // 1. Ensure Link exists above variants
        var swatches = document.querySelector('.__pf [data-pf-type="ProductVariantSwatches"]');
        if (!swatches) return;

        var linkId = 'pf-muto-comparison-link';
        var linkEl = document.getElementById(linkId);

        if (!linkEl) {
          linkEl = document.createElement('div');
          linkEl.id = linkId;
          linkEl.style.marginBottom = '15px';
          // Match theme link style
          linkEl.innerHTML = '<button type="button" class="link underlined-link" style="border:none;background:none;padding:0;cursor:pointer;text-decoration:underline;color:inherit;font-size:inherit;">Not sure which system to buy?</button>';
          
          var btn = linkEl.querySelector('button');
          btn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            openMutoModal();
          });
        }

        // Insert above variants (swatches)
        if (swatches.parentNode && swatches.previousElementSibling !== linkEl) {
          swatches.parentNode.insertBefore(linkEl, swatches);
        }

        // 2. Hide original table content if present on page (to avoid duplication/visible footer table)
        // We only want to show it inside the modal.
        var originalContent = document.querySelector('.muto-comparison-wrapper');
        if (originalContent && !originalContent.closest('#pf-muto-modal')) {
             // If it's not in our modal yet, hide it or move it to a safe holding place
             // But we'll leave it be for now, openMutoModal handles the moving.
             // We just ensure it's not visible initially if that's desired?
             // Actually, usually users want it hidden until clicked.
             // But let's check if it's already visible.
             // If it is, we might want to hide it.
             // originalContent.style.display = 'none'; // Un-comment if it shows up at bottom of page unwanted
        }

      } catch (e) {
        log('Error setting up MUTO modal', e);
      }
    }

    // --- System Tag Visibility Logic ---
    var _fetchedDescription = null;
    var _isFetchingDescription = false;
    
    function handleSystemVisibility() {
      try {
        var pid = getPageflyProductIdForSku();
        if (!pid) return;

        var pfMap = window.__pageflyProducts || {};
        var pf = pfMap[pid];
        
        if (!pf || !pf.tags) return;

        var tags = pf.tags;
        var hasSystemTag = false;
        for (var i = 0; i < tags.length; i++) {
          if (String(tags[i]).toLowerCase().indexOf('muto systems') !== -1) {
            hasSystemTag = true;
            break;
          }
        }

        if (!hasSystemTag) {
          var elementsToHide = [
            '[data-pf-type="Tabs3"]',
            '.muto-comparison-wrapper',
            '#ProductPopup-MutoComparison',
            '.product-popup-modal__opener[data-modal="#PopupModal-MutoComparison"]',
            '#pf-muto-comparison-link' // Also hide the JS-injected link if present
          ];

          elementsToHide.forEach(function(selector) {
            var els = document.querySelectorAll(selector);
            els.forEach(function(el) {
              el.style.setProperty('display', 'none', 'important');
            });
          });

          // Identify content to show full width
          var contentToShow = null;
          
          // 1. Try to find content in the "Included" tab
          var headers = document.querySelectorAll('[data-pf-type="TabHeader3"]');
          for (var j = 0; j < headers.length; j++) {
            if (headers[j].textContent.trim() === 'Included') {
              var forId = headers[j].getAttribute('for'); // e.g. pf-tab-5ee52ada-0
              if (forId) {
                // Robust conversion: pf-tab-UUID-0 -> pf-tab-UUID-content-0
                var lastDash = forId.lastIndexOf('-');
                if (lastDash > 0) {
                   var contentClass = forId.substring(0, lastDash) + '-content-' + forId.substring(lastDash + 1);
                   var c = document.querySelector('.' + contentClass);
                   // Check innerHTML to account for non-text content
                   if (c && c.innerHTML.trim().length > 0) {
                     contentToShow = c;
                   }
                }
              }
              break; 
            }
          }

          // 2. If "Included" tab empty/missing, fallback to regular description (DOM)
          if (!contentToShow) {
            contentToShow = document.querySelector('.product__description');
          }

          // 3. If still missing, check if we injected it or need to fetch it
          if (!contentToShow) {
             var injected = document.querySelector('.injected-shopify-description');
             if (injected) {
               contentToShow = injected;
             } else if (_fetchedDescription) {
               // Create fresh element from cache
               var div = document.createElement('div');
               div.className = 'product__description page-width page-width--narrow rte injected-shopify-description';
               div.innerHTML = _fetchedDescription;
               contentToShow = div;
             } else if (!_isFetchingDescription) {
               // Fetch it via AJAX
               var match = window.location.pathname.match(/\/products\/([^\/?]+)/);
               if (match && match[1]) {
                 _isFetchingDescription = true;
                 fetch('/products/' + match[1] + '.js')
                   .then(function(r){ return r.json(); })
                   .then(function(d){
                     _isFetchingDescription = false;
                     if (d && d.description) {
                       _fetchedDescription = d.description;
                       handleSystemVisibility(); // Retry
                     }
                   })
                   .catch(function(e){ 
                     _isFetchingDescription = false; 
                     log('Error fetching description', e);
                   });
               }
             }
          }

          var header = document.querySelector('.product-header');
          // Fallback anchor if header is missing: use the hidden tabs container
          var fallbackAnchor = document.querySelector('[data-pf-type="Tabs3"]');
          
          var anchor = header;
          var insertBefore = false;

          // If no header, try to insert before the hidden tabs
          if (!anchor && fallbackAnchor) {
             anchor = fallbackAnchor;
             insertBefore = true; 
          }

          if (contentToShow && anchor && anchor.parentNode) {
            // Check if already moved/placed
            var isCorrectlyPlaced = false;
            if (insertBefore) {
                isCorrectlyPlaced = (contentToShow.nextElementSibling === anchor);
            } else {
                isCorrectlyPlaced = (contentToShow.previousElementSibling === anchor);
            }

            if (!isCorrectlyPlaced) {
              if (insertBefore) {
                  anchor.parentNode.insertBefore(contentToShow, anchor);
              } else {
                  anchor.parentNode.insertBefore(contentToShow, anchor.nextSibling);
              }
              
              // Apply styles
              contentToShow.style.setProperty('display', 'block', 'important');
              contentToShow.style.setProperty('visibility', 'visible', 'important');
              contentToShow.style.setProperty('opacity', '1', 'important');
              contentToShow.style.width = '100%';
              contentToShow.style.maxWidth = '100%';
              contentToShow.style.marginTop = '3rem';
              contentToShow.style.marginBottom = '3rem';
              
              // Ensure alignment
              if (!contentToShow.classList.contains('page-width')) {
                contentToShow.classList.add('page-width');
              }
              if (anchor.classList.contains('page-width--narrow') && !contentToShow.classList.contains('page-width--narrow')) {
                 contentToShow.classList.add('page-width--narrow');
              }
            }
          }
        }
      } catch (e) {
        log('Error in handleSystemVisibility', e);
      }
    }

    function openMutoModal() {
      var modalId = 'pf-muto-modal';
      var modal = document.getElementById(modalId);
      
      if (!modal) {
        // Create modal structure
        modal = document.createElement('div');
        modal.id = modalId;
        modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:999999;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 0.3s ease;pointer-events:none;';
        
        var contentWrapper = document.createElement('div');
        contentWrapper.style.cssText = 'background:white;padding:0;border-radius:24px;max-width:95%;max-height:90vh;overflow:auto;position:relative;width:1200px;box-shadow:0 4px 12px rgba(0,0,0,0.15);';
        
        // Find original content to CLONE (not move)
        var originalContent = document.querySelector('.muto-comparison-wrapper');
        // If not found in DOM, check if we have it in a hidden template or main-product modal
        if (!originalContent) {
             var mainModalContent = document.querySelector('#PopupModal-MutoComparison .product-popup-modal__content-info');
             if (mainModalContent) {
                 originalContent = mainModalContent.querySelector('.muto-comparison-wrapper');
             }
        }

        if (originalContent) {
          // Clone the content so the original stays on the page
          var clonedContent = originalContent.cloneNode(true);
          
          // Change classes/IDs on the clone to avoid style conflicts
          clonedContent.className = 'muto-modal-comparison-wrapper';
          clonedContent.id = 'muto-modal-table';
          
          // Update nested class names to be modal-specific
          var tableContainer = clonedContent.querySelector('.muto-table-container');
          if (tableContainer) tableContainer.className = 'muto-modal-table-container';
          
          var table = clonedContent.querySelector('.muto-comparison-table');
          if (table) table.className = 'muto-modal-comparison-table';
          
          var note = clonedContent.querySelector('.muto-comparison-note');
          if (note) note.className = 'muto-modal-comparison-note';
          
          clonedContent.style.display = 'block';
          
          // Hide heading inside modal as requested
          var heading = clonedContent.querySelector('.muto-comparison-heading');
          if (heading) heading.style.display = 'none';

          contentWrapper.appendChild(clonedContent);
        } else {
          contentWrapper.innerHTML = '<p style="text-align:center;padding:2rem;">Comparison table content not found.</p>';
        }
        
        modal.appendChild(contentWrapper);
        document.body.appendChild(modal);
        
        // Close on background click
        modal.addEventListener('click', function(e) {
          if (e.target === modal) closeModal(modal);
        });
      }
      
      // Show
      modal.style.display = 'flex';
      // Trigger reflow
      void modal.offsetWidth;
      modal.style.pointerEvents = 'auto';
      modal.style.opacity = '1';
      document.body.style.overflow = 'hidden'; // Prevent body scroll
    }
    
    function closeModal(modal) {
      modal.style.opacity = '0';
      modal.style.pointerEvents = 'none';
      document.body.style.overflow = '';
      setTimeout(function() {
        modal.style.display = 'none';
      }, 300);
    }

    function applyAll() {
      // Prevent re-entrant calls (stops MutationObserver feedback loop)
      if (__isApplying__) return;
      __isApplying__ = true;
      
      // Temporarily disconnect MutationObserver to prevent feedback
      if (__mutationObserver__) {
        try { __mutationObserver__.disconnect(); } catch(_) {}
      }
      
      try {
        renameOptionLabels();
        applyToAllSelects();
        alignPriceRight();
        updateVariantSkuDisplay();
        updateSystemIndicator();
        updateCompareAtPrice();
        alignCTARight();
        alignSelectsRight();
        setupMutoComparisonModal();
        handleSystemVisibility();
      } finally {
        // Re-enable after a delay to let DOM settle
        setTimeout(function() {
          __isApplying__ = false;
          // Reconnect MutationObserver
          if (__mutationObserver__) {
            try {
              var root = document.getElementById('__pf') || document.body || document.documentElement;
              __mutationObserver__.observe(root, { childList: true, subtree: true });
            } catch(_) {}
          }
        }, 500);
      }
    }
  
    // Event wiring
    function wire() {
      document.addEventListener('change', function(e) {
        var t = e.target;
        if (t && t.matches && t.matches('select.pf-variant-select')) {
          mapSelectOptions(t);
          renameOptionLabels();
          alignPriceRight();
          updateVariantSkuDisplay();
          updateSystemIndicator();
          alignCTARight();
          alignSelectsRight();
          updateSystemIndicator();
        }
      });

    // PageFly / Theme variant change signals
    document.addEventListener('variant:changed', function() {
      setTimeout(function(){ applyAll(); updateSystemIndicator(); }, 100);
    });

    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, function() {
          setTimeout(function(){ applyAll(); updateSystemIndicator(); }, 0);
        });
      }
    } catch(_) {}

    // Mutation observer for PageFly dynamic updates
    var root = document.getElementById('__pf') || document.body || document.documentElement;
    try {
      var debounce = null;
      __mutationObserver__ = new MutationObserver(function() {
        // Skip if we're currently applying changes
        if (__isApplying__) return;
        clearTimeout(debounce);
        debounce = setTimeout(applyAll, 500); // Increased debounce to 500ms
      });
      __mutationObserver__.observe(root, { childList: true, subtree: true });
    } catch(_) {}

    // Re-align on viewport changes (keep edges synced)
    var rzTmr;
    window.addEventListener('resize', function(){
      clearTimeout(rzTmr);
      rzTmr = setTimeout(function(){
        alignPriceRight();
        updateSystemIndicator();
        updateCompareAtPrice();
        alignCTARight();
        alignSelectsRight();
        updateSystemIndicator();
      }, 100);
    });
    window.addEventListener('orientationchange', function(){
      alignPriceRight();
      updateSystemIndicator();
      updateCompareAtPrice();
      alignCTARight();
      alignSelectsRight();
      updateSystemIndicator();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyAll();
      wire();
      log('Initialized (DOMContentLoaded).');
    });
  } else {
    applyAll();
    wire();
    log('Initialized (ready).');
  }
})();